import { render, staticRenderFns } from "./set-passwd.vue?vue&type=template&id=7670322a&scoped=true&"
import script from "./set-passwd.vue?vue&type=script&lang=ts&"
export * from "./set-passwd.vue?vue&type=script&lang=ts&"
import style0 from "./set-passwd.vue?vue&type=style&index=0&id=7670322a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7670322a",
  null
  
)

export default component.exports